import React from "react";


export default function Body3({ text, color}) {
    console.log(color)
    const colors = require("../../styles/Colors.json")
    return (
        <span style={{
            fontFamily: "Roboto",
            fontWeight: "400",
            fontSize: "16px",
            lineHeight: "18px",
            color: color == undefined ? colors.colors.neutral02Color.neutral_04 : color
        }}>{text}
        </span>
    )
}   